import React from 'react';
import { SvgIcon } from '@material-ui/core';

export function UncheckedRadio() {
  return (
      <SvgIcon>
          <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="1.5" y="1.5" width="23" height="23" rx="11.5" fill="white"/>
              <rect x="1.5" y="1.5" width="22" height="22" rx="11.5" stroke="#CCCCCC"/>
          </svg>
      </SvgIcon>
  );
}

export function CheckedRadio() {
  return (
       <SvgIcon>
           <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
               <rect x="2" y="2" width="22" height="22" rx="11" fill="white"/>
               <circle cx="13" cy="13" r="5" fill="black"/>
               <rect x="3" y="3" width="20" height="20" rx="11" stroke="black" stroke-width="2"/>
           </svg>
       </SvgIcon>
  );
}
